import $ from 'jquery';
import 'magnific-popup';

let isGlobalVideoHandlerInitialized = {};

export function initVideoPopup(blockName) {
	if (Object.hasOwn(isGlobalVideoHandlerInitialized, blockName) && isGlobalVideoHandlerInitialized[blockName]) return;
	isGlobalVideoHandlerInitialized[blockName] = true;

	document.addEventListener('click', (e) => {
		const iconVideo = e.target.closest(`.${blockName}__video-icon`);
		if (!iconVideo) return;

		const poster = iconVideo.dataset.poster;
		const videoUrl = iconVideo.dataset.url;

		if (!videoUrl) return;

		$.magnificPopup.open({
			items: {
				src: `<div class="${blockName}__video-wrap"><video poster="${poster}" controls><source src="${videoUrl}" type="video/mp4"></video></div>`,
			},
			type: 'inline',
			mainClass: `${blockName}__video-popup`,
			callbacks: {
				open: function () {
					const videoEl = this.content.find('video')[0];
					if (videoEl) {
						const playPromise = videoEl.play();
						if (playPromise !== undefined) {
							playPromise.catch(error => {
								console.warn("Воспроизведение видео было прервано браузером:", error.message);
							});
						}

						const closePopupIfNotFullscreen = () => {
							const isFullscreen = !!(
								document.fullscreenElement ||
								document.webkitFullscreenElement ||
								videoEl.webkitDisplayingFullscreen
							);
							if (!isFullscreen) {
								setTimeout(() => $.magnificPopup.close(), 200);
							}
						};

						document.addEventListener('fullscreenchange', closePopupIfNotFullscreen);
						document.addEventListener('webkitfullscreenchange', closePopupIfNotFullscreen);
						videoEl.addEventListener('webkitendfullscreen', closePopupIfNotFullscreen);
						videoEl._closeHandler = closePopupIfNotFullscreen;
					}
				},
				close: function () {
					const videoEl = this.content.find('video')[0];
					if (videoEl) {
						videoEl.pause();
						videoEl.currentTime = 0;
						if (videoEl._closeHandler) {
							document.removeEventListener('fullscreenchange', videoEl._closeHandler);
							document.removeEventListener('webkitfullscreenchange', videoEl._closeHandler);
							videoEl.removeEventListener('webkitendfullscreen', videoEl._closeHandler);
						}
					}
				}
			}
		});
	});
}